// removed by extract-text-webpack-plugin
module.exports = {"base":"PanelTop_base--3FyGb","isDemo":"PanelTop_isDemo--2B2qe","inner":"PanelTop_inner--QhQAA"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/PanelTop/PanelTop.css
// module id = 1828
// module chunks = 16